/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from 'theme-ui';
import React from 'react';
import { Link } from '@bottlebooks/gatsby-theme-base';

type Props = JSX.IntrinsicAttributes & {
  url: string;
  mobileUrl?: string;
  desktopImage: React.ReactNode;
  mobileImage: React.ReactNode;
};

export default function Ad({
  url,
  mobileUrl = url,
  desktopImage,
  mobileImage,
  ...rest
}: Props) {
  return (
    <>
      <Link
        href={url}
        openInNewTab
        sx={{ display: ['none', null, 'block'] }}
        {...rest}
      >
        {desktopImage}
      </Link>
      <Link
        href={mobileUrl}
        openInNewTab
        sx={{ display: ['block', null, 'none'] }}
        {...rest}
      >
        {mobileImage}
      </Link>
    </>
  );
}
